var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop, Watch, Ref } from "vue-facing-decorator";
import { DataCollectorRegisterClient, GetDataCollectorRegisterListPaginatedQuery, AddDataCollectorRegistersCommand, AddDataCollectorRegistersRequestModel, RetryDataCollectorRegisterCommand, RetryDataCollectorRegisterRequestModel, DataCollectorRegisterModel, DataCollectorRegisterFileTypeEnum, DataCollectorRegisterStatusEnum, PaginatedEnumerableOfDataCollectorRegisterModel, SortDescription, SortDirection } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import Sorter from "@/common/utils/sorter";
import { HttpHelper } from "@/app/utils/http-helper";
import { UploadErrorHelper } from "@/app/utils/upload-error-helper";
import { DateHelper } from "@/app/utils/date-helper";
import { DownloadUtil } from "@/app/utils/download-util";
const dataCollectorRegistersClient = new DataCollectorRegisterClient(window.apiUrl);
let DataCollectorRegisterVue = class DataCollectorRegisterVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.working = false;
        this.searchAttempted = false;
        this.showRegisterModal = false;
        this.showResultModal = false;
        this.saveButtonDisabled = false;
        // Batch upload state
        this.batchFiles = [];
        // Retry state
        this.retryTarget = null;
        // Last result to display in the summary modal
        this.lastResult = null;
        // components
        this.sorter = new Sorter(new SortDescription({
            fieldName: "WhenCreated",
            direction: SortDirection.Descending
        }));
        // models
        this.query = new GetDataCollectorRegisterListPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
            companyId: this.companyId,
            sort: this.sorter.currentSort
        });
        this.data = new PaginatedEnumerableOfDataCollectorRegisterModel();
    }
    created() {
        this.search();
    }
    ;
    // get
    search() {
        if (!this.canSearch)
            return;
        if (this.working)
            return;
        if (!this.query)
            return;
        this.working = true;
        dataCollectorRegistersClient
            .getListPaginated(this.query)
            .then(response => {
            this.data = new PaginatedEnumerableOfDataCollectorRegisterModel();
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        this.search();
    }
    ;
    // computed
    get canSearch() {
        return this.companyId ? true : false;
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
    isFailed(item) {
        return item.status === DataCollectorRegisterStatusEnum.Failed;
    }
    ;
    isSucceeded(item) {
        return item.status === DataCollectorRegisterStatusEnum.Succeeded;
    }
    ;
    getDateTimeFormatted(dateTime) {
        return DateHelper.convertToFriendlyMomentTimeString(dateTime);
    }
    ;
    // -------- Add flow --------
    addBatch() {
        this.batchFiles = [];
        if (this.fileInput)
            this.fileInput.value = "";
        this.showRegisterModal = true;
    }
    ;
    filesChanged() {
        if (!this.fileInput)
            return;
        const files = this.fileInput.files;
        if (!files || !files.length)
            return;
        const maxKeySize = 1024 * 1024 * 2;
        const maxZipSize = 1024 * 1024 * 20;
        const readers = [];
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const ext = file.name.slice((Math.max(0, file.name.lastIndexOf(".")) || Infinity) + 1).toLowerCase();
            if (ext !== "key" && ext !== "zip") {
                Notifier.onError(`File "${file.name}" has an invalid extension. Only .key or .zip files are allowed.`);
                continue;
            }
            const maxSize = ext === "zip" ? maxZipSize : maxKeySize;
            if (file.size > maxSize) {
                const limitMb = ext === "zip" ? 20 : 2;
                Notifier.onError(`File "${file.name}" is too big. Please select ${ext} files smaller than ${limitMb} MB.`);
                continue;
            }
            readers.push(new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    var _a;
                    resolve({
                        fileName: file.name,
                        contentType: file.type,
                        file: ((_a = e.target) === null || _a === void 0 ? void 0 : _a.result) || "",
                    });
                };
                reader.onerror = () => resolve(null);
                reader.readAsDataURL(file);
            }));
        }
        this.saveButtonDisabled = true;
        Promise.all(readers).then((rows) => {
            this.batchFiles = rows.filter((r) => r !== null);
            this.saveButtonDisabled = false;
        });
    }
    ;
    removeBatchFile(ix) {
        this.batchFiles.splice(ix, 1);
    }
    ;
    saveBatch() {
        if (!this.batchFiles.length) {
            Notifier.onWarning("Please select at least one .key file.");
            return;
        }
        const models = this.batchFiles.map(row => new DataCollectorRegisterModel({
            companyId: this.companyId,
            fileType: DataCollectorRegisterFileTypeEnum.Controller,
            file: row.file,
            fileName: row.fileName,
            contentType: row.contentType,
        }));
        this.working = true;
        dataCollectorRegistersClient.addBatch(new AddDataCollectorRegistersCommand({
            requestModel: new AddDataCollectorRegistersRequestModel({
                companyId: this.companyId,
                files: models,
            })
        }))
            .then((result) => {
            var _a, _b, _c, _d, _e;
            this.lastResult = result;
            this.showRegisterModal = false;
            if ((_a = result === null || result === void 0 ? void 0 : result.failed) === null || _a === void 0 ? void 0 : _a.length) {
                Notifier.onWarning(`${(_c = (_b = result.succeeded) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0} file(s) uploaded, ${result.failed.length} failed.`);
            }
            else {
                Notifier.onOk(`${(_e = (_d = result === null || result === void 0 ? void 0 : result.succeeded) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0} file(s) uploaded.`);
            }
            this.showResultModal = true;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                UploadErrorHelper.notify(ex);
            });
        })
            .finally(() => {
            // Reset the working flag first — otherwise the guard in search()
            // (`if (this.working) return;`) would short-circuit the reload and
            // the grid would keep showing stale/empty data.
            this.working = false;
            // Reload the grid so freshly uploaded records — including failed
            // ones the user may need to retry — are visible behind the result
            // modal.
            this.search();
        });
    }
    ;
    cancel() {
        this.showRegisterModal = false;
    }
    ;
    // -------- Retry flow --------
    retry(item) {
        this.retryTarget = item;
        if (this.retryFileInput)
            this.retryFileInput.value = "";
        this.retryFileInput.click();
    }
    ;
    retryFileChanged() {
        var _a;
        const files = (_a = this.retryFileInput) === null || _a === void 0 ? void 0 : _a.files;
        if (!files || !files.length || !this.retryTarget)
            return;
        const file = files[0];
        if (file.size > 1024 * 1024 * 2) {
            Notifier.onError("File is too big. Please select a file smaller than 2 MB.");
            return;
        }
        const ext = file.name.slice((Math.max(0, file.name.lastIndexOf(".")) || Infinity) + 1);
        if (ext.toLowerCase() !== "key") {
            Notifier.onError("Only .key files are allowed.");
            return;
        }
        const reader = new FileReader();
        reader.onload = (e) => {
            var _a;
            const dataUrl = ((_a = e.target) === null || _a === void 0 ? void 0 : _a.result) || "";
            const target = this.retryTarget;
            const newFile = new DataCollectorRegisterModel({
                companyId: target.companyId,
                fileType: target.fileType,
                file: dataUrl,
                fileName: file.name,
                contentType: file.type,
            });
            this.working = true;
            dataCollectorRegistersClient
                .retry(new RetryDataCollectorRegisterCommand({
                requestModel: new RetryDataCollectorRegisterRequestModel({
                    id: target.id,
                    newFile: newFile,
                })
            }))
                .then(() => {
                Notifier.onOk("File uploaded.");
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    UploadErrorHelper.notify(ex);
                });
            })
                .finally(() => {
                this.working = false;
                this.retryTarget = null;
                // Reload grid after working is cleared so the search() guard
                // (`if (this.working) return;`) does not skip the reload.
                this.search();
            });
        };
        reader.readAsDataURL(file);
    }
    ;
    downloadFile(item) {
        if (!(item === null || item === void 0 ? void 0 : item.id))
            return;
        this.working = true;
        dataCollectorRegistersClient.get(item.id)
            .then((response) => {
            if (!response)
                return;
            let blob = new Blob([`${atob(response.file)}`], { type: 'text/plain;charset=utf-8' });
            DownloadUtil.downloadFile(blob, response.fileName);
            Notifier.onOk(`File downloaded!`);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Number)
], DataCollectorRegisterVue.prototype, "companyId", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], DataCollectorRegisterVue.prototype, "fileInput", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], DataCollectorRegisterVue.prototype, "retryFileInput", void 0);
__decorate([
    Watch("query.pageNo"),
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DataCollectorRegisterVue.prototype, "search", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DataCollectorRegisterVue.prototype, "onSortChanged", null);
DataCollectorRegisterVue = __decorate([
    Component({
        name: "DataCollectorRegisterVue"
    })
], DataCollectorRegisterVue);
export default DataCollectorRegisterVue;
